// src/state/settings/changeData/types.ts
var SettingsErrorsId = /* @__PURE__ */ ((SettingsErrorsId2) => {
  SettingsErrorsId2["TIME_BASED_MENU_TYPE"] = "timeBasedMenuType";
  SettingsErrorsId2["GENERIC_ERROR"] = "genericError";
  return SettingsErrorsId2;
})(SettingsErrorsId || {});
var SettingsSectionId = /* @__PURE__ */ ((SettingsSectionId2) => {
  SettingsSectionId2["ALL"] = "all";
  SettingsSectionId2["ASSOCIATIONS"] = "associations";
  SettingsSectionId2["BASIC"] = "basic";
  SettingsSectionId2["ORGANIZATION_INFORMATION"] = "organizationInformation";
  SettingsSectionId2["HOURS_OF_OPERATION"] = "hoursOfOperation";
  SettingsSectionId2["HOME"] = "home";
  SettingsSectionId2["REGISTER"] = "register";
  SettingsSectionId2["MENU"] = "menu";
  SettingsSectionId2["SETTINGS"] = "settings";
  SettingsSectionId2["MANAGEMENT"] = "management";
  SettingsSectionId2["REPORTS"] = "reports";
  SettingsSectionId2["GENERAL"] = "general";
  SettingsSectionId2["PICKUP"] = "pickup";
  SettingsSectionId2["DELIVERY"] = "delivery";
  SettingsSectionId2["PAGE_DESIGN"] = "pageDesign";
  SettingsSectionId2["TIPS"] = "tips";
  SettingsSectionId2["TAGS"] = "tags";
  SettingsSectionId2["TABLE_SERVICE"] = "tableService";
  SettingsSectionId2["QUICK_SERVICE"] = "quickService";
  SettingsSectionId2["CUSTOMER_FACING_DISPLAY"] = "customerFacingDisplay";
  SettingsSectionId2["CUSTOMER_FACING_DISPLAY_ADS"] = "customerFacingDisplayAds";
  SettingsSectionId2["TICKET_DISPLAY"] = "ticketDisplay";
  SettingsSectionId2["UPDATE_ORDER_DISPLAY"] = "updateOrderDisplay";
  SettingsSectionId2["MODIFIER_DISPLAY"] = "modifierDisplay";
  SettingsSectionId2["CUSTOMIZING_RECEIPTS_HEADER"] = "customizingReceiptsHeader";
  SettingsSectionId2["CUSTOMIZING_RECEIPTS_BODY"] = "customizingReceiptsBody";
  SettingsSectionId2["CUSTOMIZING_RECEIPTS_FOOTER"] = "customizingReceiptsFooter";
  SettingsSectionId2["PRINTER_RULES"] = "printerRules";
  SettingsSectionId2["LICENSE_SPECIFIC_PRINTER_RULES"] = "licenseSpecificPrinterRules";
  SettingsSectionId2["LICENSE_SETTINGS"] = "licenseSettings";
  SettingsSectionId2["LOCK_SCREEN"] = "lockScreen";
  SettingsSectionId2["TAXES"] = "taxes";
  SettingsSectionId2["ITEM_SORT_PRIORITY"] = "itemSortPriority";
  SettingsSectionId2["PAYMENTS"] = "payments";
  SettingsSectionId2["PREP_STATIONS"] = "prepStations";
  SettingsSectionId2["END_OF_DAY"] = "endOfDay";
  SettingsSectionId2["CUSTOMERS"] = "customers";
  SettingsSectionId2["WEB_HOME_SCREEN"] = "webHomeScreen";
  SettingsSectionId2["DUAL_PRICING"] = "dualPricing";
  SettingsSectionId2["CUSTOM_TENDERS"] = "customTenders";
  return SettingsSectionId2;
})(SettingsSectionId || {});
var SET_SETTINGS_CHANGE_DATA = "SET_SETTINGS_CHANGE_DATA";
var SET_SETTINGS_DIFF_OBJECT = "SET_SETTINGS_DIFF_OBJECT";
var SET_SETTINGS_CHANGE_DATA_VALUES = "SET_SETTINGS_CHANGE_DATA_VALUES";
var RESET_SETTINGS_CHANGE_DATA = "RESET_SETTINGS_CHANGE_DATA";
var UPDATE_SETTINGS_CHANGE_DATA_VALUES = "UPDATE_SETTINGS_CHANGE_DATA_VALUES";
var SET_SELECTED_SETTINGS_LOCATIONS = "SET_SELECTED_SETTINGS_LOCATIONS";
var RESET_SETTINGS_CHANGES = "RESET_SETTINGS_CHANGES";
var SET_SETTINGS_ERRORS = "SET_SETTINGS_ERRORS";
var UPDATE_SETTINGS_ERRORS = "UPDATE_SETTINGS_ERRORS";
var CLEAR_SETTINGS_ERROR = "CLEAR_SETTINGS_ERROR";

export { CLEAR_SETTINGS_ERROR, RESET_SETTINGS_CHANGES, RESET_SETTINGS_CHANGE_DATA, SET_SELECTED_SETTINGS_LOCATIONS, SET_SETTINGS_CHANGE_DATA, SET_SETTINGS_CHANGE_DATA_VALUES, SET_SETTINGS_DIFF_OBJECT, SET_SETTINGS_ERRORS, SettingsErrorsId, SettingsSectionId, UPDATE_SETTINGS_CHANGE_DATA_VALUES, UPDATE_SETTINGS_ERRORS };
